import proto from '../../protocol'

import {
    CHAT
} from '../modulesNames'

// import {
// } from '../gettersTypes'

import {
    ACT_TASKS_GET_TASKS,
    ACT_TASKS_ADD_TASK,
    ACT_TASKS_UPDATE_TASK,
    ACT_TASKS_DELETE_TASKS,
    ACT_TASKS_HANDLE_TASK_CHANGE,
    ACT_CHAT_SCH_MESSAGE_CHANGE,
} from '../actionsTypes'

// import {
// } from '../mutationsTypes'


import { taskType } from '../../declarations'

// // state
// const state = {
// }

// actions
const actions = {
    async [ACT_TASKS_GET_TASKS]({ }, taskPayload) {
        // console.log("🚀 ~ tasks.js:47 ~ taskPayload:", taskPayload)
        const type = taskType.ACTION, fromId = 0, count = 0 
        // console.log("🚀 ~ tasks.js:49 ~ type:", type)
        const _payload = { type, fromId, count, payload: taskPayload }
        // console.log("🚀 ~ tasks.js:51 ~ _payload:", _payload)
        const tasks = await proto.getDeferredTasks(_payload)
        // console.log("🚀 ~ tasks.js:53 ~ ACT_TASKS_GET_TASKS tasks:", tasks)
        return tasks
    },
    [ACT_TASKS_ADD_TASK]({ }, params) {
        const nowUnixTime = date_helper.getCurrentUnixTime()
        // console.log("🚀 ~ tasks.js:53 ~ nowUnixTime:", nowUnixTime)
        const { taskPayload, time = nowUnixTime } = params
        console.log("🚀 ~ tasks.js:45 ~ ACT_TASKS_ADD_TASK time:", time)
        const payload = {
            type: taskType.ACTION,
            time,
            payload: taskPayload
        }
        return new Promise(async (resolve, reject) => {
            try {
                const taskId = await proto.addDeferredTask(payload)
                console.log("🚀 ~ tasks.js:54 ~ ACT_TASKS_ADD_TASK taskId:", taskId)
                resolve(taskId)
            } catch (error) {
                console.log("🚀 ~ tasks.js:57 ~ error:", error)
                reject(error)
            }
        })
    },
    async [ACT_TASKS_UPDATE_TASK]({ }, params) {
        console.log("🚀 ~ tasks.js:64 ~ ACT_TASKS_UPDATE_TASK params:", params)
        const nowUnixTime = date_helper.getCurrentUnixTime()
        console.log("🚀 ~ tasks.js:66 ~ ACT_TASKS_UPDATE_TASK nowUnixTime:", nowUnixTime)
        const { taskId, time = nowUnixTime, payload } = params
        console.log("🚀 ~ tasks.js:68 ~ ACT_TASKS_UPDATE_TASK payload:", payload)
        const _payload = {
            taskId,
            type: taskType.ACTION,
            time,
            payload
        }
        console.log("🚀 ~ tasks.js:75 ~ ACT_TASKS_UPDATE_TASK _payload:", _payload)
        const replyTaskUpdate = await proto.updateDeferredTask(_payload)
        console.log("🚀 ~ tasks.js:77 ~ ACT_TASKS_UPDATE_TASK replyTaskUpdate:", replyTaskUpdate)
    },
    async [ACT_TASKS_DELETE_TASKS]({ }, params) {
        const { taskIds } = params
        console.log("🚀 ~ tasks.js:81 ~ ACT_TASKS_DELETE_TASKS taskIds:", taskIds)
        const payload = { taskIds }
        await proto.deleteDeferredTasks(payload)
    },
    async [ACT_TASKS_HANDLE_TASK_CHANGE]({ dispatch }, params) {
        console.log("🚀 ~ tasks.js:86 ~ ACT_TASKS_HANDLE_TASK_CHANGE params:", params)
        const { type } = params
        dispatch(`${CHAT}/${ACT_CHAT_SCH_MESSAGE_CHANGE}`, params, { root: true })
    },
}

export default {
    namespaced: true,
    actions,
}
